/**
 * Gets seconds elapsed since epoch, in seconds.
 *
 * @returns Time (in seconds) since epoch, with decimals
 */
export function getSecondsSinceEpoch() {
  return new Date().getTime() / 1000
}
